import { ToggleMaskDeadzoneDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useToggleMaskDeadzone(
  cameraId: string,
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/camera/${cameraId}/toggleMaskDeadzone`;

  const request = new Request(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<null, ToggleMaskDeadzoneDTO>(request, {
    onSuccessInvalidationKeys: [['cameras']],
    onSuccess,
    onError,
  });
}

export default useToggleMaskDeadzone;
